import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  createComponentExtension,
} from '@backstage/core-plugin-api';
import { cicdPromoterApiRef, CicdPromoterApiClient } from './api';
import { cicdPromoterRouteRef } from './routes';

export const cicdPromoterPlugin = createPlugin({
  id: 'cicd-promoter',
  featureFlags: [{ name: 'cicd-promoter' }],
  apis: [
    createApiFactory({
      api: cicdPromoterApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CicdPromoterApiClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: cicdPromoterRouteRef,
  },
});

export const CicdPromoterEntityTab = cicdPromoterPlugin.provide(
  createComponentExtension({
    name: 'CicdPromoterEntityTab',
    component: {
      lazy: () =>
        import('./components/CicdPromoterEntityTab/CicdPromoterEntityTab').then(
          m => m.CicdPromoterEntityTab,
        ),
    },
  }),
);
